import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getSkillSheet } from '../data/skillSheets';

const SkillSheetDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    
    const skillSheetNumber = id ? parseInt(id, 10) : undefined;
    const skillSheet = skillSheetNumber ? getSkillSheet(skillSheetNumber) : undefined;

    const handleBackToList = () => {
        navigate('/skill-sheets');
    };

    if (!skillSheet) {
        return (
            <div className="content-container">
                <div className="content-section" style={{textAlign: 'center'}}>
                    <h1 className="text-title-xl">Skill Sheet Not Found</h1>
                    <p className="text-body-lg">The requested skill sheet could not be found.</p>
                    <button onClick={handleBackToList} className="btn btn-primary" style={{marginTop: 'var(--spacing-lg)'}}>
                        Back to Skill Sheets
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="content-container">
            <button onClick={handleBackToList} className="btn btn-secondary" style={{marginBottom: 'var(--spacing-lg)'}}>
                ← Back to Skill Sheets
            </button>
            
            <div className="glass-header">
                <div>
                    <h1 className="text-title-xl">
                        Skill Sheet {skillSheet.skill_sheet_number}: {skillSheet.skill_area}
                    </h1>
                    <div style={{display: 'flex', gap: 'var(--spacing-lg)', marginTop: 'var(--spacing-md)'}}>
                        <span className="text-caption">JPR: {skillSheet.jpr}</span>
                        <span className="text-caption">NFPA {skillSheet.nfpa_standard}</span>
                    </div>
                </div>
            </div>

            {skillSheet.conditions && (
                <div className="content-section">
                    <h2 className="text-title-lg">Conditions</h2>
                    <p className="text-body-md">{skillSheet.conditions}</p>
                </div>
            )}

            <div className="content-section">
                <h2 className="text-title-lg">Task</h2>
                <p className="text-body-md">{skillSheet.task}</p>
            </div>

            <div className="content-section">
                <h2 className="text-title-lg">Performance Outcome</h2>
                <p className="text-body-md">{skillSheet.performance_outcome}</p>
            </div>

            <div className="content-section">
                <h2 className="text-title-lg">Task Steps</h2>
                <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)'}}>
                    {skillSheet.task_steps.map((step) => (
                        <div key={step.number} style={{display: 'flex', gap: 'var(--spacing-md)', alignItems: 'flex-start'}}>
                            <span className="text-title-sm" style={{minWidth: '2rem', color: 'var(--primary-color)'}}>{step.number}:</span>
                            <span className="text-body-md">{step.task_step}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="content-section" style={{textAlign: 'center'}}>
                <div style={{display: 'flex', gap: 'var(--spacing-md)', justifyContent: 'center', flexWrap: 'wrap'}}>
                    <button className="btn btn-secondary">Follow Along</button>
                    <button className="btn btn-secondary">Arrange</button>
                </div>
            </div>
        </div>
    );
};

export default SkillSheetDetail;